import CashDateItem from "../../../components/organisms/report/cash_date_item";
import React, {useEffect, useState} from "react";
import {Moment} from "moment";
import moment from "moment/moment";
import SportBetLogTable from "./component/table";
import {useLocation} from "react-router";
import api from "../../../api";
import SportLogModal from "./component/log_modal";
import SportDetailModal from "./component/detail_modal";

export default function BetLogSport() {
  const dateFormat = 'DD/MM/YYYY';

  const [loading, setLoading] = useState<boolean>(false)
  const [date, setDate] = useState<[Moment, Moment]>([moment(new Date(), dateFormat), moment(new Date(), dateFormat)])
  const [data, setData] = useState<any[]>([])

  const [detail, setDetail] = useState<any>()
  const [showDetail, setShowDetail] = useState<boolean>(false)

  const [logs, setLog] = useState<any>(null)
  const [showLog, setShowLog] = useState<boolean>(false)

  const location = useLocation()

  useEffect(() => {
    loadData()
  }, [location.key, date])

  const loadData = async() => {
    setLoading(true)
    const {response, error} = await api.report.betLogSport(date[0].format('YYYY-MM-DD'), date[1].format('YYYY-MM-DD'),)
    if (!error) {
      console.log(response.data)
      setData(response.data)
    }
    setLoading(false)
  }
  const search = async () => {
    loadData()
  }

  const getDBDetail = async (orderNo: any) => {
    setLoading(true)
    const {response, error} = await api.report.betLogSportDetail(orderNo)
    loadData();
  }

  const showLogDetail = async (id: any) => {
    setLoading(true)
    const {response, error} = await api.report.getBetLogDetail(id)
    if(!error) {
      setLog(response.items)
      console.log(response.items)
      setShowLog(true)
    }
    setLoading(false)
  }

  const showMatchDetail = async (data: any) => {
    setDetail(data.detailList)
    setShowDetail(true);
    console.log(data)
  }

  return(<div className='mt-4'>
    <CashDateItem loading={loading} dateFormat={dateFormat} dates={date} dateChange={setDate} search={search}/>
    <SportBetLogTable
      loading={loading}
      data={data}
      getMatchDetail={getDBDetail}
      showLog={showLogDetail}
      showMatchDetail={showMatchDetail}
    />

    <SportLogModal open={showLog} items={logs} onClose={() => {setShowLog(false)}} />
    <SportDetailModal open={showDetail} details={detail} onClose={() => setShowDetail(false)} />
  </div>)
}

